import React from 'react';
import { ListItemText, ListItem, Checkbox } from '@mui/material';
import { ListChildComponentProps } from 'react-window';
import { Concept } from 'reduxState/store/concept/types';
import { selectedConceptsType } from './ConceptManager';
import { ComputerIcon, StoreIcon } from '../Icons';

interface ConceptProps extends ListChildComponentProps {
  onSelect: (concept: Concept) => void;
  selectedConcepts: selectedConceptsType;
}

const ConceptComponent = ({ index, style, data, selectedConcepts, onSelect }: ConceptProps): JSX.Element => {
  const concept = data[index] as Concept;
  const isSelected = selectedConcepts.get(concept.id) !== undefined;

  return (
    <ListItem style={style} className={`concept ${index % 2 ? 'bg-white' : 'bg-gray-200'}`} key={index}>
      <Checkbox checked={isSelected} onChange={() => onSelect(concept)} />
      {concept.kind === 'merchant' ? (
        <span className="mr-2 cursor-help" title="Merchant" aria-label="Merchant">
          <StoreIcon className="w-6 h-6 text-wildfire-orange" />
        </span>
      ) : concept.kind === 'domain' ? (
        <span className="mr-2 cursor-help" title="Domain" aria-label="Domain">
          <ComputerIcon className="w-6 h-6 text-wildfire-purple" />
        </span>
      ) : null}
      <ListItemText primary={concept.value} />
    </ListItem>
  );
};

export default ConceptComponent;
